// project-imports
import { getRequest, postRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - AI ||============================== //

export async function handleAI(action: APIAction) {
  switch (action.method) {
    case 'read-prompt-list':
      return getRequest(`/ai/prompts?agent-id=${action.id}`);
    case 'create-prompt':
      return postRequest(`/ai/prompts`, action.data);
    case 'read-generation-list':
      return getRequest(`/ai/generations?agent-id=${action.id}`);
    case 'create-generation':
      return postRequest(`/ai/generations`, action.data);
    case 'create-generate':
      return postRequest(`/ai/generate?agent-id=${action.id}`, action.data);
    case 'generate-test':
      return postRequest(`/ai/generate-test?agent-id=${action.id}&prompt_id=${action.data.prompt_key}`, action.data);
    case 'read-descriptions-test':
      return getRequest(`/ai/descriptions-test?agent-id=${action.id}`);
    case 'read-descriptions':
      return getRequest(`/ai/descriptions?agent-id=${action.id}`);
    case 'read-description-detail':
      return getRequest(
        `/ai/descriptions/detail?agent-id=${action.id}&development-id=${action.data.developmentId}&language=${action.data.language}`
      );
    default:
      console.info('[ApiManager > handleApiAction > handleAI] - Unknown method');
      break;
  }
}
